import { apiClient } from '@/lib/api-client';
import type { ApiResponse, Alert, AlertStatus } from '@/types/api';

interface GetAlertsParams {
  status?: AlertStatus;
  propertyId?: string;
}

export async function getAlerts(params: GetAlertsParams = {}): Promise<ApiResponse<Alert[]>> {
  const response = await apiClient.get<ApiResponse<Alert[]>>('/alerts', { params });
  return response.data;
}

export async function getAlert(id: string): Promise<ApiResponse<Alert>> {
  const response = await apiClient.get<ApiResponse<Alert>>(`/alerts/${id}`);
  return response.data;
}

export async function acknowledgeAlert(id: string): Promise<ApiResponse<null>> {
  const response = await apiClient.post<ApiResponse<null>>(`/alerts/${id}/acknowledge`);
  return response.data;
}

export async function resolveAlert(id: string): Promise<ApiResponse<null>> {
  const response = await apiClient.post<ApiResponse<null>>(`/alerts/${id}/resolve`);
  return response.data;
}

export async function getActiveAlertCount(): Promise<ApiResponse<number>> {
  const response = await apiClient.get<ApiResponse<number>>('/alerts/active/count');
  return response.data;
}
